import {
  CalendarIcon,
  ClockIcon,
  HeartIcon,
  LockClosedIcon,
  SparklesIcon,
  UserGroupIcon
} from "@heroicons/react/24/outline"

const features = [
  {
    icon: SparklesIcon,
    title: "Digital time capsules",
    description:
      "Fill a capsule with your thoughts and memories, set a future date, and let the anticipation build."
  },
  {
    icon: UserGroupIcon,
    title: "Collaborate together",
    description:
      "Invite friends and family to add their own memories to a shared capsule."
  },
  {
    icon: LockClosedIcon,
    title: "Private & secure",
    description: "Your memories stay safely locked away until the opening date arrives."
  },
  {
    icon: ClockIcon,
    title: "Countdown timer",
    description: "Watch the excitement build as you count down to the big reveal."
  },
  {
    icon: CalendarIcon,
    title: "Open in the future",
    description: "Pick any future date to unlock and rediscover your preserved memories."
  },
  {
    icon: HeartIcon,
    title: "Built for connection",
    description:
      "Relive milestones with the people who matter and celebrate how far you've come."
  }
]

export const FeatureSection = () => {
  return (
    <section className="bg-white py-24 dark:bg-gray-900 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-balance text-3xl font-semibold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Create memories that last
          </h2>
          <p className="mt-4 text-lg/8 text-gray-600 dark:text-gray-300">
            Digital time capsules for your most precious moments
          </p>
        </div>

        <div className="mx-auto mt-16 grid max-w-2xl grid-cols-1 gap-6 sm:grid-cols-2 lg:max-w-none lg:grid-cols-3">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="rounded-2xl bg-gray-50 p-6 ring-1 ring-gray-200 transition hover:shadow-md dark:bg-gray-800/50 dark:ring-white/10"
            >
              <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-600/10 text-primary-600 dark:bg-primary-500/10 dark:text-primary-400">
                <feature.icon aria-hidden="true" className="h-6 w-6" />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-gray-900 dark:text-white">
                {feature.title}
              </h3>
              <p className="mt-2 text-sm/6 text-gray-600 dark:text-gray-300">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
